import { render, staticRenderFns } from "./AddChat.vue?vue&type=template&id=6d20ac00&"
import script from "./AddChat.vue?vue&type=script&lang=js&"
export * from "./AddChat.vue?vue&type=script&lang=js&"
import style0 from "./AddChat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports